<template lang="pug">
yz-dialog(v-model="dialogValue" persistent max-width="496")
  yz-card
    yz-dialog-normal-header(title="Register patient and add items to visit" @close="onClose")
    .pa-6
      .yz-heading-8.neutral700--text Are you sure you want to proceed this action?
      .yz-regular-body-md.neutral700--text.mt-2 Registering this patient will add the selected items to the current visit and make them available for use.
      .yz-regular-body-md.neutral700--text.mt-2 Click "Confirm" to continue.
      yz-card.mt-4.pa-4(v-if="isUnpaid" color="red-100")
        .d-flex.align-start
          yz-icon.mr-3(color="danger500" size="20") mdi-alert-circle
          .yz-regular-body-sm.neutral700--text This {{ typeLabel }} has not been paid yet. You can still proceed with the registration.
    yz-divider
    yz-card-actions.d-flex.align-center.justify-end.px-6.py-3(style="gap: 12px")
      yz-btn(size="lg" text text-color="yz-neutral-700" label="Cancel" @click="onClose")
      yz-btn(size="lg" label="Confirm" dark @click="onConfirm")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'reservation'
    },
    reservationData: {
      type: Object,
      default: null
    }
  },
  computed: {
    dialogValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    typeLabel () {
      return this.type === 'reservation' ? 'reservation' : 'pre-order'
    },
    isUnpaid () {
      if (!this.reservationData) return false
      return this.reservationData.payment_status === 'unpaid'
    }
  },
  methods: {
    onClose () {
      this.dialogValue = false
    },
    onConfirm () {
      this.$emit('confirm')
    }
  }
}
</script>
